// extracted by mini-css-extract-plugin
export default {"main":"SupportDirectory_main__PmOXN","heading":"SupportDirectory_heading__XhOVD","tiles_container":"SupportDirectory_tiles_container__VOPYy"};